import React, { useEffect } from 'react'
import { useDataChange, useDataValue } from 'Simple/Data.js'
import View from './view.js'
import { preserveLineBreaks } from 'Data/format.js'

export default function Logic(props) {
  let content = useDataValue({
    context: 'content',
    viewPath: props.viewPath,
  })
  let editor = useDataValue({
    context: 'editor',
    viewPath: props.viewPath,
  })
  let change = useDataChange({
    context: 'editor',
    path: 'comms_template_url',
    viewPath: props.viewPath,
  })

  useEffect(() => {
    editor.api.insertContent(preserveLineBreaks(content))
    change(null)
  }, [])

  return <View {...props} />
}
